/**
 * DOS518 — Integrazione ASTUTO
 * mockAdapter.ts — Dati demo per test e configurazione iniziale.
 *
 * Simula un intervento AIB con dati fittizi siciliani.
 * Etichettati chiaramente "(DEMO)" nel diario per non confondere dati reali.
 */

import type { AstutoAdapter } from './baseAdapter';
import type { AstutoResult } from '../types';

const MOCK_DATA = {
  codice:      'DEMO-2025-001',
  data:        new Date().toLocaleDateString('it-IT'),
  ora:         new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }),
  comune:      'Linguaglossa (DEMO)',
  localita:    'Contrada Rovittello',
  latitudine:  '37.8359',
  longitudine: '15.1253',
  personale: [
    { matricola: '12345', nome: 'Marco',    cognome: 'Ferraro',  qualifica: 'Capo Squadra',    telefono: '335100001', radio: 'CH-1', ente: 'CFRS CT' },
    { matricola: '23456', nome: 'Giuseppe', cognome: 'Amato',    qualifica: 'Autista 1° Grado', telefono: '335100002', radio: 'CH-1', ente: 'CFRS CT' },
    { matricola: '34567', nome: 'Salvatore',cognome: 'Grasso',   qualifica: 'Operatore',        telefono: '335100003', radio: 'CH-2', ente: 'CFRS ME' },
    { matricola: '45678', nome: 'Carmelo',  cognome: 'Catalano', qualifica: 'Volontario AIB',   telefono: '335100004', radio: 'CH-2', ente: 'AIB Etna' },
  ],
  mezziTerrestri: [
    { sigla: 'APS-CT-01', tipo: 'APS',        targa: 'EA123AB', ente: 'CFRS CT' },
    { sigla: 'ABT-CT-02', tipo: 'Autobotte',  targa: 'EA456CD', ente: 'CFRS CT' },
  ],
  mezziAerei: [
    { sigla: 'ELI-CT-A1', tipo: 'Elicottero', modello: 'AgustaWestland AW139' },
  ],
};

export class MockAdapter implements AstutoAdapter {
  readonly name = 'Demo / Test (dati campione)';

  async fetch(): Promise<AstutoResult> {
    // Simula latenza realistica
    await new Promise((resolve) => setTimeout(resolve, 450));
    return { ok: true, data: MOCK_DATA };
  }
}
